import { faPencil, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { Card, CardBody, CardHeader } from 'reactstrap'
import {
  getApplicationTodos,
  setFormSubmitted,
} from 'store/Recruitment/actions'
import CreateTodoModal from './CreateTodoModal'
import moment from 'moment'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { deleteApplicationTodo } from 'store/Recruitment/actions'

function Todo() {
  const dispatch = useDispatch()
  const location = useLocation()

  const { applicationTodos } = useSelector((store) => store.recruitment)

  const [showModal, setShowModal] = useState(false)
  const [todo, setTodo] = useState(null)

  const columns = [
    {
      headerName: 'Title',
      field: 'title',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Description',
      field: 'description',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Priority',
      field: 'priority',
      cellRenderer: (params) => (
        <span className='text-capitalize'>{params.value}</span>
      ),
    },
    {
      headerName: 'Due Date',
      field: 'due_date',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
    },
    {
      headerName: 'Assigned By',
      field: 'assignedBy',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Assigned To',
      field: 'assignedTo',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Action',
      field: 'action',
      unSortIcon: false,
      sortable: false,
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faPencil}
            title='Edit'
            role='button'
            className='text-info'
            onClick={() => {
              setTodo(params.data)
              setShowModal(true)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faTrash}
            title='Delete'
            role='button'
            className='text-danger'
            onClick={() =>
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  customFn: () =>
                    dispatch(
                      deleteApplicationTodo(
                        params.data.id,
                        location?.search?.split('=')?.at(1)
                      )
                    ),
                })
              )
            }
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  useEffect(() => {
    dispatch(getApplicationTodos(location?.search?.split('=')?.at(1)))
  }, [dispatch, location?.search])

  useEffect(() => {
    if (!showModal) {
      dispatch(setFormSubmitted(false))
      setTodo(null)
    }
  }, [showModal, dispatch])

  console.log(applicationTodos, 'leart108')

  return (
    <Card>
      <CardHeader className='title d-flex justify-content-between'>
        To Do
        <button className='btn btn-info' onClick={() => setShowModal(true)}>
          + Create Todo
        </button>
      </CardHeader>
      <CardBody>
        <div
          className='ag-theme-alpine'
          style={{ height: '600px', width: '100%' }}
        >
          <AgGridReact
            columnDefs={columns}
            rowData={applicationTodos}
            defaultColDef={defaultColDef}
          />
        </div>
      </CardBody>
      {showModal && (
        <CreateTodoModal
          showModal={showModal}
          setShowModal={setShowModal}
          todo={todo}
        />
      )}
    </Card>
  )
}

export default Todo
